const CART_TIER_PROGRESS_STORAGE_KEY = 'cartTierProgressPct';
const CART_TIER_COUNT_STORAGE_KEY = 'cartTierItemCount';
const CART_TIER_CHECKPOINTS = [
  { qty: 2, selector: '.cart-tier-progress__step--t2' },
  { qty: 3, selector: '.cart-tier-progress__step--t3' },
  { qty: 4, selector: '.cart-tier-progress__step--t4' },
  { qty: 5, selector: '.cart-tier-progress__step--t5' },
];

let cartTierInitFrame = 0;

function getTargetScale(root) {
  const value = Number.parseFloat(root.dataset.progress);
  if (Number.isNaN(value)) return 0;
  return Math.min(1, Math.max(0, value / 100));
}

function celebrateReachedCheckpoints(root, previousCount, currentCount) {
  if (Number.isNaN(previousCount) || currentCount <= previousCount) return;

  CART_TIER_CHECKPOINTS.forEach(({ qty, selector }) => {
    if (previousCount >= qty || currentCount < qty) return;

    const node = root.querySelector(`${selector} .cart-tier-progress__node`);
    if (!node) return;

    const clearRing = () => {
      node.classList.remove('is-just-reached');
      node.removeEventListener('animationend', onRingEnd);
    };
    const onRingEnd = (event) => {
      if (event.animationName && event.animationName !== 'cart-tier-node-ring') return;
      clearRing();
    };

    node.classList.remove('is-just-reached');
    void node.offsetWidth;
    node.addEventListener('animationend', onRingEnd);
    node.classList.add('is-just-reached');
  });
}

function applyCartTierProgressFill(root, animateFromStored = true) {
  const fill = root.querySelector('.cart-tier-progress__fill');
  if (!fill) return;

  const target = getTargetScale(root);
  const stored = Number.parseFloat(sessionStorage.getItem(CART_TIER_PROGRESS_STORAGE_KEY));
  const start = animateFromStored && !Number.isNaN(stored) ? Math.min(1, Math.max(0, stored)) : target;
  const previousCount = Number.parseInt(sessionStorage.getItem(CART_TIER_COUNT_STORAGE_KEY), 10);
  const currentCount = Number.parseInt(root.dataset.itemCount, 10);

  fill.style.transition = 'none';
  fill.style.transform = `scaleX(${start})`;
  void fill.offsetWidth;
  fill.style.transition = '';

  window.requestAnimationFrame(() => {
    fill.style.transform = `scaleX(${target})`;
    sessionStorage.setItem(CART_TIER_PROGRESS_STORAGE_KEY, String(target));

    if (!Number.isNaN(currentCount)) {
      celebrateReachedCheckpoints(root, previousCount, currentCount);
      sessionStorage.setItem(CART_TIER_COUNT_STORAGE_KEY, String(currentCount));
    }
  });
}

function initCartTierProgress() {
  if (cartTierInitFrame) return;

  cartTierInitFrame = window.requestAnimationFrame(() => {
    cartTierInitFrame = 0;
    document.querySelectorAll('[data-cart-tier-progress]').forEach((root) => {
      applyCartTierProgressFill(root, true);
    });
  });
}

window.initCartTierProgress = initCartTierProgress;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, initCartTierProgress);
}

document.addEventListener('DOMContentLoaded', initCartTierProgress);
document.addEventListener('shopify:section:load', initCartTierProgress);
